import React, { useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as actions from './actions'
import PropTypes from 'prop-types'
import { StatusTracker, WorkFlowPageLayout } from 'components'
import * as Types from 'types'

const propTypes = {
  children: PropTypes.node.isRequired,
  currentStage: PropTypes.string,
  title: PropTypes.string.isRequired,
  stages: PropTypes.arrayOf(Types.stage),
  subject: PropTypes.string.isRequired,
  clearParticipantsData: PropTypes.func.isRequired,
  clearCompleteServicesAgreementForm: PropTypes.func.isRequired,
}

const defaultProps = {
  currentStage: null,
  stages: [],
}

function Layout({
  currentStage,
  children,
  title,
  stages,
  subject,
  clearParticipantsData,
  clearCompleteServicesAgreementForm,
}) {
  useEffect(() => {
    return () => {
      clearParticipantsData()
      clearCompleteServicesAgreementForm()
    }
  }, [])

  return (
    <WorkFlowPageLayout title={title} exitPromptSubject={subject}>
      <StatusTracker stages={stages} currentStageName={currentStage} />

      {children}
    </WorkFlowPageLayout>
  )
}

Layout.propTypes = propTypes

Layout.defaultProps = defaultProps

function mapStateToProps(/* state */) {
  return {}
}

const mapDispatchToProps = {
  clearParticipantsData: actions.clearParticipantsData,
  clearCompleteServicesAgreementForm:
    actions.clearCompleteServicesAgreementForm,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout)
